/**
 * `Sheet`'s look on roles (DESIGN_SYSTEM.md §5.2). The FRAME (`scrim`, the web `dialog`, the phone `sheet`)
 * is drawn from roles for every caller: its values were already the roles' (black at 50 %, white). The
 * CHROME (`header`, `title`, `subtitle`, `handle`) is drawn from here for v2 (`appearance="pos"`) and
 * from `legacyLook.ts` for the live My Orders sheets (QD5).
 */
import { defineVariants } from "@rista/ui/library/theme/variants";

export const sheetLook = defineVariants({
  slots: ["scrim", "dialog", "sheet", "header", "title", "subtitle", "handle"],
  base: (t) => ({
    scrim: { flex: 1, backgroundColor: t.color.surface.scrim },
    dialog: {
      backgroundColor: t.color.surface.raised,
      overflow: "hidden",
      alignSelf: "center",
      marginTop: "auto",
      marginBottom: "auto",
      maxHeight: "85%",
    },
    sheet: { backgroundColor: t.color.surface.raised, borderTopStartRadius: t.radius.sheet, borderTopEndRadius: t.radius.sheet },
    header: { padding: t.space.xl, borderBottomWidth: 1, borderBottomColor: t.color.border.subtle },
    title: { ...t.type.heading, color: t.color.text.primary },
    subtitle: { ...t.type.body, color: t.color.text.secondary, marginTop: t.space.xs },
    handle: { backgroundColor: t.color.border.default, width: 48 },
  }),
});
